import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import styled from 'styled-components'

import { useDispatch } from 'react-redux'
import { $gray_100, $gray_300, $gray_600 } from 'utils/colors'
import { _ } from 'utils'
import { showErrorNotification } from '../../../notifications/notificationsSlice'

// eslint-disable-next-line max-len
export const DOCUMENTS_ONLY = 'application/pdf, application/vnd.ms-powerpoint, application/vnd.ms-powerpoint, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const VIDEOS_ONLY = 'video/mp4'

const S = {
    Section: styled.section`
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-width: 2px;
        border-radius: 2px;
        border-color: ${$gray_300};
        border-style: dashed;
        background-color: ${$gray_100};
        color: ${$gray_600};
        outline: none;
        transition: border 0.24s ease-in-out;
        margin-bottom: 20px;
    `,
    Container: styled.div`
        display: block;
        width: 100%;
        text-align: center;
        position: relative;
        cursor: pointer;
        padding: 20px;

        &:focus {
            outline: none;
        }
    `,
    Text: styled.p`
        margin: 0;
    `,
    Input: styled.input`
        display: block;
        opacity: 0;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    `,

    Filename: styled.div`
        display: flex;
        margin-bottom: 36px;
    `,
    FilenameText: styled.p`
        display: block;
        margin: auto auto auto 0;
        flex-grow: 1;
        flex-shrink: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
}

export interface EditableFileUploadProps {
    onFileSelect?(file: File | null): void
    accept?: string
    maxSize?: number
}

const EditableFileUpload = ({
    onFileSelect,
    accept = DOCUMENTS_ONLY,
    maxSize = 25, // in mb
}: EditableFileUploadProps) => {
    const dispatch = useDispatch()
    const [error, setError] = useState('')
    const dropHandler = (files: File[]) => {
        if (files.length > 0) {
            const file = files[0]
            const size = file.size / 1024 / 1024 // in MB
            if (size > maxSize) {
                setError(`Max file size is ${maxSize}MB. `
                    + `The file you uploaded is ${Math.round(size)}MB.`)
            } else {
                onFileSelect(file)
            }
        }
    }

    const onWrongFileType = () => {
        dispatch(showErrorNotification('Not accepted file type'))
    }

    return (
        <>
            <Dropzone onDrop={dropHandler} accept={accept} onDropRejected={onWrongFileType}>
                {({ getRootProps, getInputProps }) => (
                    <>
                        <S.Section>
                            <S.Container {...getRootProps()}>
                                <S.Text>{_('form.file_upload')}</S.Text>
                                <S.Input {...getInputProps()} />
                            </S.Container>
                        </S.Section>
                        { error && <span className="mb-2">{error}</span> }
                    </>
                )}
            </Dropzone>
        </>
    )
}

export default EditableFileUpload
